import { logger } from "../constant/winston";
import { store } from "../stateManager";
import { UPDATE_INITIAL_ONBOARDING_DATA } from "../stateManager/store/onboarding/types";
import { Http } from "./axois"

export const getOnboarding = async(username: string) => {
    try {
        const result = await Http.get(`/users/${username}/onboardingState`).toPromise()
        return result;
    } catch (error) {
        logger.error("Failed to get onboarding data")
    }
}

export const updateOnboarding = async (username: string, payload: any, update?: boolean) => {
   try {
        const res: any = await Http.put(`/users/${username}/onboardingState`, payload).toPromise();
        if (res && res.length && !update) {
            store.dispatch({
                type: UPDATE_INITIAL_ONBOARDING_DATA,
                payload: res[0].onboarding_status
            })
        }
        return res;
   } catch (error) {
        logger.error("Failed to update onboarding data")
   }
}